<template>
  <XyzTransition appear xyz="fade">
    <div class="main">
      <client-topbar v-if="isCurrentUserClient" />
      <topbar v-else />
      <sidebar v-if="!isCurrentUserClient" />
      <router-view :style="marginStyle" />
    </div>
  </XyzTransition>
</template>

<script>
import { mapGetters } from 'vuex'
import ClientTopbar from '@/components/tops/ClientTopbar'
import Topbar from '@/components/tops/Topbar'
import Sidebar from '@/components/sides/Sidebar'

export default {
  name: 'main-wrapper',
  components: {
    ClientTopbar,
    Topbar,
    Sidebar
  },

  computed: {
    ...mapGetters([
      'isCurrentUserClient'
    ]),

    marginStyle () {
      return { 'margin-left': this.isCurrentUserClient ? '0' : '300px' }
    }
  },

  mounted() {
    this.$socket.connect()
  }
}
</script>

<style>
.main {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: $white-grey;
}
</style>
